<template>
    <div class="columns is-mobile is-centered has-background-primary p-2">
        <h1 class="title is-4 has-text-white">Gestionale LMC</h1>
    </div>
    <br>
    <br>
    <div class="box"  v-if="schermoLargo">
        <div class="columns is-mobile is-centered has-text-centered">
            <div>Ciao {{ credenzialiUtente.nome }}&nbsp;!</div>
        </div>
        <div class="columns is-mobile is-centered has-text-centered" v-if="!ricercaCompleta && dbClienti">
            <div>Sono stati caricati {{ Object.keys(dbClienti).length }} clienti.</div>
        </div>
        <div class="columns is-mobile is-centered has-text-centered">
            <div>Prosegui selezionando una voce dal menu.</div>
        </div>
        <br>
        <div class="columns is-mobile is-centered has-text-centered">
            <h2 class="subtitle">LMC srl</h2>
        </div>
        <div class="columns is-mobile is-centered has-text-centered">
            Sede operativa: Stradale Ivrea 41, 10019 Strambino (TO)
        </div>
        <div class="columns is-mobile is-centered has-text-centered">
            Sede legale: Via Gobetti 33, 10015 Ivrea (TO)
        </div>
        <div class="columns is-mobile is-centered has-text-centered">
            Telefono: &nbsp; <a href="tel:+3901251925603">+39 0125 1925603</a>
        </div>
        <div class="columns is-mobile is-centered has-text-centered">
            Mail: &nbsp; <a href="mailto:info@lmc-soluzioni.it">info@lmc-soluzioni.it</a>
        </div>
        <div class="columns is-mobile is-centered has-text-centered">
            PEC: &nbsp; <a href="mailto:comunicazioni@pec.lmc-soluzioni.it">comunicazioni@pec.lmc-soluzioni.it</a>
        </div>
        <div class="columns is-mobile is-centered has-text-centered">
            Partita IVA / CF: 10650450017
        </div>
        <div class="columns is-mobile is-centered has-text-centered">
            Codice univoco: PPX7BLB
        </div>
        <div class="columns is-mobile is-centered has-text-centered">
            Numero REA: TO-1151130
        </div>
        <div class="columns is-mobile is-centered has-text-centered">
            Numero Albo Artigiani: TO-343117
        </div>
        <div class="columns is-mobile is-centered has-text-centered">
            N. iscr. al Registro Imprese di Torino: 10650450017
        </div>
        <div class="columns is-mobile is-centered has-text-centered">
            Codice ATECO: 43.22.01
        </div>
        <div class="columns is-mobile is-centered has-text-centered">
            Posizione INPS: 8144455515
        </div>
        <div class="columns is-mobile is-centered has-text-centered">
            Posizione INAIL: 21389435-52
        </div>        
    </div>

    <div class="box"  v-if="!schermoLargo">
        <div class="columns is-mobile is-centered has-text-centered">
            <div>Ciao {{ credenzialiUtente.nome }}&nbsp;!</div>
        </div>
        <div class="columns is-mobile is-centered has-text-centered" v-if="!ricercaCompleta && dbClienti">
            <div>Sono stati caricati {{ Object.keys(dbClienti).length }} clienti.</div>
        </div>
        <br>
        <div class="columns is-mobile is-centered has-text-centered">
            <h2 class="subtitle">LMC srl</h2>
        </div>
        <div class="columns is-mobile is-centered has-text-centered">
            Sede operativa
        </div>
        <div class="columns is-mobile is-centered has-text-centered is-italic">
            Stradale Ivrea 41, 10019 Strambino (TO)
        </div>
        <div class="columns is-mobile is-centered has-text-centered">
            Sede legale
        </div>
        <div class="columns is-mobile is-centered has-text-centered is-italic">
            Via Gobetti 33, 10015 Ivrea (TO)
        </div>
        <div class="columns is-mobile is-centered has-text-centered">
            Telefono
        </div>
        <div class="columns is-mobile is-centered has-text-centered is-italic">
            <a href="tel:+3901251925603">+39 0125 1925603</a>
        </div>
        <div class="columns is-mobile is-centered has-text-centered">
            Mail
        </div>
        <div class="columns is-mobile is-centered has-text-centered is-italic">
            <a href="mailto:info@lmc-soluzioni.it">info@lmc-soluzioni.it</a>
        </div>
        <div class="columns is-mobile is-centered has-text-centered">
            PEC
        </div>
        <div class="columns is-mobile is-centered has-text-centered is-italic">
            <a href="mailto:comunicazioni@pec.lmc-soluzioni.it">comunicazioni@pec.lmc-soluzioni.it</a>
        </div>
        <div class="columns is-mobile is-centered has-text-centered">
            Partita IVA / CF
        </div>
        <div class="columns is-mobile is-centered has-text-centered is-italic">
            10650450017
        </div>
        <div class="columns is-mobile is-centered has-text-centered">
            Codice univoco
        </div>
        <div class="columns is-mobile is-centered has-text-centered is-italic">
            PPX7BLB
        </div>
        <div class="columns is-mobile is-centered has-text-centered">
            Numero REA
        </div>
        <div class="columns is-mobile is-centered has-text-centered is-italic">
            TO-1151130
        </div>
        <div class="columns is-mobile is-centered has-text-centered">
            Numero Albo Artigiani
        </div>
        <div class="columns is-mobile is-centered has-text-centered is-italic">
            TO-343117
        </div>
        <div class="columns is-mobile is-centered has-text-centered">
            N. iscr. al Registro Imprese di Torino
        </div>
        <div class="columns is-mobile is-centered has-text-centered is-italic">
            10650450017
        </div>
        <div class="columns is-mobile is-centered has-text-centered">
            Codice ATECO
        </div>
        <div class="columns is-mobile is-centered has-text-centered is-italic">
            43.22.0
        </div>
        <div class="columns is-mobile is-centered has-text-centered">
            Posizione INPS
        </div>
        <div class="columns is-mobile is-centered has-text-centered is-italic">
            8144455515
        </div>
        <div class="columns is-mobile is-centered has-text-centered">
            Posizione INAIL
        </div>
        <div class="columns is-mobile is-centered has-text-centered is-italic">
            21389435-52
        </div>
    </div>

</template>

<script setup>
    import { credenzialiUtente } from '../code/firebase';
    import { ricercaCompleta, schermoLargo } from '../code/utilita'
    import { dbClienti } from '../code/gestioneDB'

</script>